import React from "react";
import { labelUtils } from "../Util";
import FormGroupWrapper from "./FormGroupWrapper";

import store from "../../../../store";
import { setRendererFormState } from "../../../../store/slices/commonSlice";
import { useEffect } from "react";

const TextArea = ({
  arrEle,
  newElfromJSON,
  fieldEle,
  formState,
  displayLabelKey,
  databaseKey,
}) => {
  let key = databaseKey ? databaseKey : displayLabelKey;

  const displayNo = fieldEle?.["display-no"];
  const displayYes = fieldEle?.["display-yes"];
  const displayOther = fieldEle?.["display-other"];
  const parentSelectedValue = displayNo ? formState[displayNo] : "";

  // const shouldDisplay = parentSelectedValue?.toLowerCase() === "no";
  const shouldDisplay =
    parentSelectedValue?.toLowerCase() === "no" ||
    parentSelectedValue?.toLowerCase() === "other";

  const parentValueOther = displayOther ? formState[displayOther] : "";

  const parentValue = displayYes ? formState[displayYes] : "";
  const display = parentValue?.toLowerCase() === "yes";
  const shouldDisplayOther = parentValueOther?.toLowerCase() === "other";

  useEffect(() => {
    if (displayYes && display === false) {
      store.dispatch(setRendererFormState({ key: databaseKey, value: "" }));
    }
    if (displayNo && shouldDisplay === false) {
      store.dispatch(setRendererFormState({ key: databaseKey, value: "" }));
    }
    if (displayOther && !shouldDisplayOther) {
      store.dispatch(setRendererFormState({ key: databaseKey, value: "" }));
    }
  }, [
    displayYes,
    displayNo,
    display,
    shouldDisplay,
    databaseKey,
    shouldDisplayOther,
  ]);

  if (displayNo && !shouldDisplay) {
    return null;
  }

  if (displayYes && !display) {
    return null;
  }

  if (displayOther && !shouldDisplayOther) {
    return null;
  }

  return (
    <FormGroupWrapper
      arrEle={arrEle}
      newElfromJSON={newElfromJSON}
      fieldEle={fieldEle}
    >
      <div
        className="form-builder-element"
        style={{ width: labelUtils.getElementWidth(fieldEle) }}
      >
        <textarea
          id={newElfromJSON}
          rows={fieldEle?.["display-rows"]}
          className="form-control mandatory"
          type="text"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
          placeholder={fieldEle?.["display-placeholder"]}
          disabled={fieldEle?.["display-disabled"] === 1}
          name={key}
          required={fieldEle?.["display-required"] === 1}
          minLength={fieldEle?.["validation-minlength"]}
          maxLength={fieldEle?.["validation-maxlength"]}
          value={formState[key] || ""}
          onChange={(e) =>
            store.dispatch(setRendererFormState({ key, value: e.target.value }))
          }
        />
        <div className="invalid-feedback">This field is required</div>
        {fieldEle?.["display-description"] && (
          <div className="form-text text-muted formElementDesc">
            {fieldEle?.["display-description"]}
          </div>
        )}
      </div>
    </FormGroupWrapper>
  );
};

export default TextArea;
